import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';
import { AutomatSearchFilterSuperAdmin } from "../models/automat";

@Injectable()
export class AutomatService extends HeaderService {

    getAutomatGroupsByFirm(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getAutomatGroupsByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getAutomatsByFirm(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getAutomatsByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    addAutomat(data): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'super-admin-automat',
            JSON.stringify(data),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getBeaconsForAddAutomat(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getBeaconsByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getDevicesForAddAutomat(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getDevicesByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getAllAutomats(page: number, params: AutomatSearchFilterSuperAdmin): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'get-all-automats-for-super-admin/'+ page,
            JSON.stringify(params),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    /*-----------Locations----------------*/

    getAllCities(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-all-cities',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getDistrictsByCity(id: string): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-district-by-city-key/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getNeighborhoodsByDistrict(id: string): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-neighborhood-by-district-key/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    /*-----------Locations End----------------*/

    getModemsForAddAutomat(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getModemsByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getSimsForAddAutomat(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getSimCardsByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getVPossesForAddAutomat(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getVPosByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getAutomatKindsForAddAutomat(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'automat-kinds/',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    addCashlessConfig(data): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'add-cashless-config/',
            JSON.stringify(data),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    addAutomatImage(data, id): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'automat-image/' + id,
            data,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getAutomatInfo(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-edit-automat/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getCashlessInfo(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-cashless-config/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deleteAutomat(id): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'automat/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateAutomat(automat, cashlessConfig, id): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'automat/' + id,
            JSON.stringify({automat: automat, cashlessConfig:cashlessConfig}),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateCashlessConfig(data): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'update-cashless-config/',
            JSON.stringify(data),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    getInfoDescription(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getInfoDescription/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateDescription(data, id: String): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'updateInfoDescription/' + id,
            data,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/automat.service.ts